<template>
  <div class="apply-step apply-step--terminal">
    <div class="apply-step__icon">🙏</div>
    <h2>Tu aplicación está en revisión</h2>
    <p>Gracias por aplicar. Estamos revisando tu información y te contactaremos pronto por WhatsApp.</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ResultNoAprueba',
  mounted() { this.clearAll() },
  methods: { ...mapActions('apply', ['clearAll']) },
}
</script>

<style src="../apply-step.css" scoped></style>
<style scoped>
.apply-step--terminal { text-align: center; padding: 2rem 1rem; }
.apply-step__icon { font-size: 4rem; margin-bottom: 1rem; }
</style>
